exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-marquee{width:100%;overflow:hidden}.vux-marquee-box{padding:0;height:auto}.vux-marquee-box,.vux-marquee-box li{margin:0;width:100%}", ""]);

// exports
